/**
 * @module LightboxCarouse
 * dependencies:
 * /dist/Packages/Plugins/TechDivision.Carousel/Resources/Private/JavaScript/libs/slick.1.6.0.custom.js
 * /Creaton.Product/Resources/Private/JavaScript/libs/SlickLightbox/SlickLightbox.js
 *
 */
;(function LightboxCarousel() {
    function LightboxCarousel($dom) {
        /**
         * // local object availability
         * @type {LightboxCarousel}
         * @private
         */
        var _this = this


        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.renderSlickCarousel()
            this.renderSlickLightbox()
        }

        /**
         * @method renderSlickCarousel
         * @returns {undefined}
         */
        this.renderSlickCarousel = function () {
            $dom.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2000,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ],
            })
        }

        /**
         * @method renderSlickLightbox
         * @returns {undefined}
         */
        this.renderSlickLightbox = function () {
            $dom.slickLightbox({
                itemSelector: '[rel="technical-drawings--lightbox-item"]',
                navigateByKeyboard: true,
                caption: 'technical-drawing-caption',
            })
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.LightboxCarousel = LightboxCarousel
})()

$(document).ready(function () {
    var $technicalDrawingsLightboxCarousel = $('[rel="technical-drawings--lightbox-carousel"]')
    if ($technicalDrawingsLightboxCarousel.length >= 1) {
        new window.Creaton.LightboxCarousel($technicalDrawingsLightboxCarousel)
    }
})
